import { useEffect, useState } from "react";

// Phone width.
export const PHONE_QUERY = "(max-width: 767px)";

// matchesQuery says whether the screen matches now. False where it can't tell.
export function matchesQuery(query) {
  try { return window.matchMedia(query).matches; } catch (e) { return false; }
}

// useMediaQuery is matchesQuery that updates when the screen changes.
export default function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => matchesQuery(query));
  useEffect(() => {
    let media;
    try { media = window.matchMedia(query); } catch (e) { return undefined; }
    const onChange = () => setMatches(media.matches);
    if (media.addEventListener) media.addEventListener("change", onChange);
    return () => { if (media.removeEventListener) media.removeEventListener("change", onChange); };
  }, [query]);
  return matches;
}
